import React from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

export const Collapsible = ({
  isOpen,
  onToggle,
  checkboxLabel,
  isChecked,
  isIndeterminate,
  onCheckboxChange,
  children,
  className = '',
  level = 0
}) => {
  // Create a ref for the checkbox to set indeterminate state
  const checkboxRef = React.useRef(null);

  // Set indeterminate property (not possible with just React props)
  React.useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = isIndeterminate;
    }
  }, [isIndeterminate]);

  return (
    <div className={clsx('transition-all duration-200 ease-in-out', className)}>
      <div
        className={clsx(
          'flex items-center p-4 cursor-pointer transition-colors duration-150',
          level === 0
            ? 'bg-white hover:bg-gray-50 border-b border-gray-200'
            : level === 1
            ? 'bg-white pl-8 hover:bg-gray-50'
            : ''
        )}
        onClick={onToggle}>
        <button
          type="button"
          className="mr-3 text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-150"
          aria-label={isOpen ? 'Collapse' : 'Expand'}
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}>
          {isOpen ? (
            <ChevronDownIcon className="h-5 w-5" />
          ) : (
            <ChevronRightIcon className="h-5 w-5" />
          )}
        </button>

        <label
          className="flex items-center cursor-pointer flex-grow"
          onClick={(e) => e.stopPropagation()}>
          <div className="relative flex items-center justify-center w-5 h-5">
            <input
              ref={checkboxRef}
              type="checkbox"
              checked={isChecked}
              onChange={(e) => {
                e.stopPropagation();
                onCheckboxChange();
              }}
              className={clsx(
                'form-checkbox w-5 h-5 transition duration-150 ease-in-out rounded',
                level === 0
                  ? 'border-gray-300 focus:ring-gray-500'
                  : 'border-gray-300 focus:ring-gray-500',
                isIndeterminate && 'opacity-0'
              )}
              style={{ accentColor: '#1f2937', color: '#1f2937' }}
            />
            {/* Custom indeterminate indicator */}
            {isIndeterminate && (
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none bg-white border border-gray-300 rounded">
                <div className="w-2.5 h-0.5 bg-gray-800 rounded-sm"></div>
              </div>
            )}
          </div>
          <span
            className={clsx(
              'ml-3 w-full',
              level === 0 ? 'font-medium text-gray-800' : 'text-gray-700'
            )}>
            {checkboxLabel}
          </span>
        </label>
      </div>

      {isOpen && (
        <div
          className={clsx(
            'overflow-hidden transition-all duration-200 ease-in-out bg-gray-50',
            level === 0 ? 'pl-0' : level === 1 ? 'pl-4' : ''
          )}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Collapsible;
